// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_container__fCb66 {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.card_containerLoader__T3Wm2 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
}

.card_card__XoCn7 {
  font-family: 'IBM Plex Sans', sans-serif;
  margin: 0.7em 0.5em;
  padding: 0.8em 1em;
  border: 2px solid #055437;
  /* border : 2px solid #2d3436; */
  border-radius: 1em;
  /* color : #00b894; */
  color: #055437;
}

::-webkit-scrollbar {
  width: 0.2em;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: gray;
}

.card_cardButton__n0K4M {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  height: 130px;
  margin: 0.7em 0.5em;
  padding: 0.8em 1em;
  border: 2px solid #055437;
  border-radius: 1em;
  color: #055437;
  background: none;
  cursor: pointer;
  position: relative;
}

.card_cardButton__n0K4M .card_logo__tl6fs {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card_cardButton__n0K4M .card_text__rBDvS {
  font-family: 'IBM Plex Sans', sans-serif;
  overflow-y: auto;
  max-height: 50px;
  word-break: break-word;
  overflow-x: visible;
  font-size: 16px;
  position: absolute;
  top: 55%;
}

.card_dCardButton__MUR-H .card_logo__tl6fs {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.card_dCardButton__MUR-H .card_text__rBDvS {
  font-family: 'IBM Plex Sans', sans-serif;
  overflow-y: auto;
  max-height: 50px;
  word-break: break-word;
  overflow-x: visible;
  font-size: 16px;
  position: absolute;
  top: 55%;
}

.card_cardButton__n0K4M:hover {
  background: #81ecec;
  transition-duration: 200ms;
}

.card_dCardButton__MUR-H {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  height: 130px;
  margin: 0.7em 0.5em;
  padding: 0.8em 1em;
  border: 2px solid #055437;
  border-radius: 1em;
  color: #055437;
  background: none;
  position: relative;
}

.card_cardBox__\\+22aN {
  margin: 0.7em 0.5em 1.5em 0;
  padding: 0.5em 1em;
  border: 2px solid #055437;
  color: #055437;
  font-family: 'IBM Plex Sans', sans-serif;
}
.card_cardBox__\\+22aN .card_title__tpVSx {
  font-size: 1.4em;
  text-align: left;
  font-weight: 600;
  padding-bottom: 0.5em;
}

.card_cardBox__\\+22aN .card_content__WPz7A {
  font-size: 1.1em;
  text-align: left;
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
}

.card_grow__4KQur {
  flex-grow: 1;
}

.card_card__XoCn7 .card_content__WPz7A {
  font-size: 0.9em;
  font-weight: 600;
}

.card_card__XoCn7 .card_title__tpVSx {
  font-size: 1em;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/components/Card/card.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');\n\n.container {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.containerLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.card {\n  font-family: 'IBM Plex Sans', sans-serif;\n  margin: 0.7em 0.5em;\n  padding: 0.8em 1em;\n  border: 2px solid #055437;\n  /* border : 2px solid #2d3436; */\n  border-radius: 1em;\n  /* color : #00b894; */\n  color: #055437;\n}\n\n::-webkit-scrollbar {\n  width: 0.2em;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.cardButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 120px;\n  height: 130px;\n  margin: 0.7em 0.5em;\n  padding: 0.8em 1em;\n  border: 2px solid #055437;\n  border-radius: 1em;\n  color: #055437;\n  background: none;\n  cursor: pointer;\n  position: relative;\n}\n\n.cardButton .logo {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.cardButton .text {\n  font-family: 'IBM Plex Sans', sans-serif;\n  overflow-y: auto;\n  max-height: 50px;\n  word-break: break-word;\n  overflow-x: visible;\n  font-size: 16px;\n  position: absolute;\n  top: 55%;\n}\n\n.dCardButton .logo {\n  position: absolute;\n  top: 30%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.dCardButton .text {\n  font-family: 'IBM Plex Sans', sans-serif;\n  overflow-y: auto;\n  max-height: 50px;\n  word-break: break-word;\n  overflow-x: visible;\n  font-size: 16px;\n  position: absolute;\n  top: 55%;\n}\n\n.cardButton:hover {\n  background: #81ecec;\n  transition-duration: 200ms;\n}\n\n.dCardButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 120px;\n  height: 130px;\n  margin: 0.7em 0.5em;\n  padding: 0.8em 1em;\n  border: 2px solid #055437;\n  border-radius: 1em;\n  color: #055437;\n  background: none;\n  position: relative;\n}\n\n.cardBox {\n  margin: 0.7em 0.5em 1.5em 0;\n  padding: 0.5em 1em;\n  border: 2px solid #055437;\n  color: #055437;\n  font-family: 'IBM Plex Sans', sans-serif;\n}\n.cardBox .title {\n  font-size: 1.4em;\n  text-align: left;\n  font-weight: 600;\n  padding-bottom: 0.5em;\n}\n\n.cardBox .content {\n  font-size: 1.1em;\n  text-align: left;\n  font-weight: 500;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n.card .content {\n  font-size: 0.9em;\n  font-weight: 600;\n}\n\n.card .title {\n  font-size: 1em;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `card_container__fCb66`,
	"containerLoader": `card_containerLoader__T3Wm2`,
	"card": `card_card__XoCn7`,
	"cardButton": `card_cardButton__n0K4M`,
	"logo": `card_logo__tl6fs`,
	"text": `card_text__rBDvS`,
	"dCardButton": `card_dCardButton__MUR-H`,
	"cardBox": `card_cardBox__+22aN`,
	"title": `card_title__tpVSx`,
	"content": `card_content__WPz7A`,
	"grow": `card_grow__4KQur`
};
export default ___CSS_LOADER_EXPORT___;
